export default __webpack_public_path__ + "b315df6346d2fda6d02ffc2b30a174d8.png";